<template>
  <article class="accordion" v-if="vg_businessLoyality.id">
    <div class="accordion-header">
      <h3 class="is-size-5 has-text-weight-bold">Rewards <img src="@/assets/img/yup.png"/></h3>
      <span class="action hover-opacity-7" @click="editStep()">EDIT</span>
    </div>
    <div class="accordion-body">
      <div class="accordion-content">
        <div class="checkout-accordion-content-wrap">
          <h3 class="accordion-title is-size-5 has-text-weight-bold">Rewards</h3>
          <div class="checkout-accordion-content">
            
            <!-- Reward for loggedin user plus user doesnt have subscribe loyality programme -->
  
            <!-- <div class="" v-if="vg_userId"> -->
              <!-- <template v-if="!vg_userLoyalitySubscription"> 
                <h3 class="is-size-6 has-text-weight-semibold mb10">Great News!</h3>
                <p class="mb10">You are moments away from earning <strong>{{ vg_cartLoyalityPointsObj.points_redeemable ? vg_cartLoyalityPointsObj.points_redeemable : 0 }} points</strong> on this purchase, all you have to do is opt-in for <strong>{{ vg_businessLoyality.name }}</strong>.</p>
                <div class="field mt20 mb10">
                    <ValidationProvider name="terms and conditions" ref="loyality_terms_conditions" rules="must_be_checked" v-slot="{ errors }">
                      <input class="is-checkradio" v-model="loyality.terms" id="checkoutloyalityOptIn" type="checkbox" name="checkoutloyalityOptIn" :value="1">
                      <label for="checkoutloyalityOptIn">I agree to the <router-link target="_blank" :to="{ name: 'TermsConditions'}">Terms & Conditions</router-link> and <router-link target="_blank" :to="{ name: 'PrivacyPolicy'}">Privacy Policy</router-link> for {{ vg_businessLoyality.name }}</label>
                      <span class="validation-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                <div class="reward-join-actions">
                  <a @click.prevent="skip()"  href="#" class="button font-color hover-opacity-7 btn-skip has-text-semibold-18">SKIP</a>
                  <a @click.prevent="joinLoyalityProgramme()" href="#" class="min-w-200 button is-primary btn-complete has-text-semibold-18" >JOIN</a>
                </div>
              </template> -->
            <!-- </div> -->

            <!-- Reward for guest user -->
            <div v-if="!vg_userId">
              <!-- 2 cases before click join_now -->
              <template v-if="join_now == false">
               <template v-if="vg_cartLoyalityPointsObj.points_earned && (vg_cartLoyalityPointsObj.points_earned > 0)">
                <h3 class="is-size-6 has-text-weight-semibold mb10">Great News!</h3>
                <p class="mb10 has-text-weight-semibold">You're moments away from earning {{ vg_cartLoyalityPointsObj.points_earned ? new Intl.NumberFormat().format(vg_cartLoyalityPointsObj.points_earned) : 0 }} points on this purchase when you sign up below!</p>
               </template>

               <template v-else >
                  <h3 class="is-size-6 has-text-weight-semibold mb10">Oh No!</h3>
                <p class="mb10 has-text-weight-semibold">It looks like you aren't going to earn points this purchase, but you can still sign-up and earn points in the future!</p>
               </template>
                <p>Our {{ vg_businessLoyality.name }} provides exciting rewards! Earn points by visiting stores, on purchases, and more!</p>
                <p class="is-size-6 has-text-centered has-text-weight-semibold mb10 mt10">Join With:</p>
                <div class="reward-join-with">
                  <a href="#" class="social-login-signup-icon"  @click.prevent="loginWithGoogle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg>
                  </a> &nbsp; 
                  <a href="#" class="social-login-signup-icon"  @click.prevent="loginWithFacebook">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path  fill="#4285F4" d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
                  </a>  
                </div>
                <div class="reward-join-actions">
                  <a @click.prevent="skip()"  href="#" class="button hover-text-secondary btn-skip">SKIP</a>
                  <a @click.prevent="join_now = true" href="#" class="min-w-200 button hover-opacity-7 bg-secondary text-white btn-complete" >JOIN MANUALLY</a>
                </div>
              </template>

              <template v-else>
                <template v-if="vg_cartLoyalityPointsObj.points_earned && (vg_cartLoyalityPointsObj.points_earned > 0)">
                <h3 class="is-size-6 has-text-weight-semibold mb10">Great News!</h3>
                <p class="mb10 has-text-weight-semibold">You're moments away from earning {{ vg_cartLoyalityPointsObj.points_earned ? new Intl.NumberFormat().format(vg_cartLoyalityPointsObj.points_earned) : 0 }} points on this purchase when you sign up below!</p>
               </template>

               <template v-else >
                <h3 class="is-size-6 has-text-weight-semibold mb10">Oh No!</h3>
                <p class="mb10 has-text-weight-semibold">It looks like you aren't going to earn points this purchase, but you can still sign-up and earn points in the future!</p>
               </template>

                <p>Our {{ vg_businessLoyality.name }} provides rich rewards for those who earn points by visiting stores, referring friends, and other simple actions!</p>

                <p class="is-size-6 has-text-centered has-text-weight-semibold mb10 mt10">Join With:</p>
                <div class="reward-join-with">
                  <a href="#" class="social-login-signup-icon"  @click.prevent="registerWithGoogle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg>
                  </a> &nbsp; 
                  <a href="#" class="social-login-signup-icon"  @click.prevent="registerWithFacebook">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path  fill="#4285F4" d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
                  </a>  
                </div>
             
                <form class="reward-join-now-signup" ref="registerForm">
                  <p class="or-spacer"><span>Or</span></p>
                  <div class="form-field-inline">
                    <div class="field">
                      <div class="control">
                        <validation-provider name="first name" ref="first_name" rules="required">
                          <template #default="{ errors }">
                            <input
                              class="input"
                              name="First Name"
                              v-model="form.first_name"
                              type="text"
                              placeholder="First Name *"
                            />
                            <span class="validation-error">{{ errors[0] }}</span>
                          </template>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="field">
                      <div class="control">
                        <validation-provider name="last name" ref="last_name" rules="required">
                          <template #default="{ errors }">
                            <input
                              class="input"
                              name="Last Name"
                              v-model="form.last_name"
                              type="text"
                              placeholder="Last Name *"
                            />
                            <span class="validation-error">{{ errors[0] }}</span>
                          </template>
                        </validation-provider>
                      </div>
                    </div>
                  </div>

                  <div class="form-field-inline">
                    <div class="field">
                      <div class="control mt10" v-show="signupTypeSocial">
                        Email: {{ form.email }}
                      </div>
                      <div class="control" v-show="!signupTypeSocial">
                        <validation-provider name="email" ref="email" rules="required|email"> 
                          <template #default="{ errors }">
                              <input
                                class="input"
                                name="Email"
                                v-model="form.email"
                                type="email"
                                placeholder="Email *"
                              />
                              <span class="validation-error">{{ errors[0] }}</span>
                            </template>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="field">
                      <div class="control">
                        <validation-provider name="phone" ref="phone" rules="phone_number_only_if_has_value">
                          <template #default="{ errors }">
                            <input
                              class="input hide-arrow"
                              name="Phone"
                              v-model="form.phone"
                              type="number"
                              onkeydown="if(event.key==='.'){event.preventDefault();}"
                              placeholder="Phone Number *"
                            />
                            <span class="validation-error">{{ errors[0] }}</span>
                          </template>
                        </validation-provider>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="form-field-inline">
                    <div class="field">
                      <div class="control">
                        <validation-provider name="date of birth" ref="date_of_birth" rules="required"> 
                          <template #default="{ errors }">
                            <vuejs-datepicker v-model="form.dob" :maximum-view="'year'" :typeable="false" :initial-view="'year'" :minimum-view="'day'" full-month-name:="true"  :format="'dd/MM/yyyy'" class="input" id="dob" placeholder="Birthday (dd/mm/yy)"></vuejs-datepicker>
                            <span class="validation-error">{{ errors[0] }}</span>
                          </template>
                        </validation-provider>
                        <div class="mt-5">
                          <p class="is-size-7 font-color"><span class="font-color mr10">*</span>Must match government-issued ID.</p>
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <div class="control">
                        <div class="is-full-width"> 
                          <validation-provider name="Province" ref="province" rules="required">
                            <template #default="{ errors }">
                              <div class="select is-full-width"> 
                                <select v-model="form.province" class="province-select">
                                  <option value="" disabled>--Province--</option>
                                  <option  v-for="item in vg_provinces" selected v-bind:key="item.value" :value="item.value">{{ item.name }}</option>
                                </select>
                              </div>
                              <span class="validation-error">{{ errors[0] }}</span>
                            </template>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <!-- <div class="form-field-inline">
                    <div class="field">
                      <div class="control">
                        <ValidationProvider ref="password" name="Password" rules="required|verify_password|min:8" v-slot="{ errors }" vid="password">
                          <input 
                            v-model="form.password" 
                            class="input" 
                            type="password" 
                            placeholder="Password">
                          <span class="validation-error" v-if="errors[0] " v-html="errors[0] "></span>
                        </ValidationProvider>   
                      </div>
                    </div>

                    <div class="field">
                      <div class="control">
                        <ValidationProvider name="Confirm Password" ref="confirm_password" rules="required|confirmed:password" v-slot="{ errors }">
                          <input 
                            v-model="form.confirm_password" 
                            class="input" 
                            type="password" 
                            placeholder="Confirm Password">
                          <span class="validation-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>  
                  </div> -->
  
                  <div class="field register-page-policies-list reward-signup-policies pl0">
                    <p class="has-text-weight-semibold mb10">Security policies according to your province law</p> <!-- Ontario -->
                    <ul>
                      <!-- <li>You must be {{ getProvinceAge(form.province) ? getProvinceAge(form.province) : '19' }} years of age or older.</li> -->
                      <li>The information on your ID and the information on your account must match.</li> 
                      <li>To retrieve your order, you will need to show a valid government-issued photo ID.</li>
                    </ul>
                    <div class="mt20 mb10 checkout-offers">
                      <input class="is-checkradio" v-model="form.marketing_notification" id="signupOptIn" type="checkbox" name="signupOptIn" :value="1">
                      <label for="signupOptIn" class="is-size-6"><span>Sign up for new offers and discounts</span></label>
                    </div>

                    <!-- <div class="field mt20 mb10 reward-signup-terms">
                      <ValidationProvider name="terms and conditions" ref="signup_terms_conditions" rules="must_be_checked" v-slot="{ errors }">
                        <input class="is-checkradio" v-model="form.terms" id="signup_terms_conditions" type="checkbox" name="signup_terms_conditions" :value="1">
                        <label for="signup_terms_conditions" class="is-size-6">
                          <span>I agree to the <router-link target="_blank" :to="{ name: 'TermsConditions'}">Terms & Conditions</router-link> and <router-link target="_blank" :to="{ name: 'PrivacyPolicy'}">Privacy Policy</router-link> for {{vg_businessLoyality.name }}</span>
                        </label>
                        <span class="validation-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div> -->
                  </div>
                </form>

                <div class="reward-join-actions reward-signup-actions">
                  <div class="reward-signup-action-left">
                    <p class="is-size-6">By signing up, you agree to the Budler <router-link class="hover-text-primary" target="_blank" :to="{ name: 'TermsConditions', params: { business_slug: $route.params.business_slug }, query: $route.query}">Terms of Use</router-link> and <router-link class="hover-text-primary" target="_blank" :to="{ name: 'PrivacyPolicy', params: { business_slug: $route.params.business_slug }, query: $route.query}">Privacy Policy</router-link></p>
                  </div>
                  <div class="reward-signup-action-right">
                    <a @click.prevent="skip()"  href="#" class="button hover-text-secondary btn-skip">SKIP</a>
                    <a @click.prevent="join()" href="#" class="button bg-secondary text-white hover-opacity-7 btn-complete min-w-200">JOIN</a>
                  </div>
                </div>
              </template>

            </div>

          </div>
        </div>
      </div>
    </div>
  </article>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import vuejsDatepicker from 'vuejs-datepicker';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import LoginApis from '@/Components/Controllers/LoginApis';
import SignupApis from '@/Components/Controllers/SignupApis';

import moment from 'moment';
import Env from '@/env';

export default {
  name: 'CheckoutReward',
  components: {
    vuejsDatepicker,
  },
  data() {
    return {
      join_now: false,
      loyality: {
        terms: false,
      },
      // Register
      form: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        marketing_notification: false,
        redirect_url: '',
        social_type: '',
        social_id: '',
        // Need to add 
        business_id: '',
        business_name: '',
        business_slug: '',
        logo_url: '',
        location_id: '',
        location_slug: '',
      },
      signupTypeSocial: false,
      socialAccessToken: '',
    };
  },
  computed: {
    vg_provinces() {
      return Env.provinces;
    },
    ...mapGetters({
      vg_cartId: "cart/id",
      vg_userId: "getLoggedInUserId",
      vg_businessProfile: "businessprofile/detail",
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_cartTax: "cart/cartTax",
      vg_cartPromoCode: "cart/promocode",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_pendingItemOnCart: "cart/pendingItem",
      vg_userLoyalitySubscription: "userloyalitysubscription/subscribed",
      vg_cartLoyalityPointsObj: "cart/loyalityPointsObj",
    }),

  },

   watch: {
    
    form: {
      handler: function () {
        if(this.form.social_type && this.form.social_id){
          this.signupTypeSocial = true;
        } else {
          this.signupTypeSocial = false;
        }
      },
      deep: true
    },
    'form.phone'(val) {
      if(val){
        if(val.indexOf(".") != -1) {
          this.form.phone = val.replace(/\./g,"");
        }
        let newval = val.trim();
        if(val.length > 10){
          newval = newval.slice(0,10)
        } 
        this.form.phone = newval;
      }
    },
    'form.email'(val) {
      this.form.email = val ? val.replaceAll(/\s/g,'').trim() : '';
    },
  },

  // beforeDestroy() {
  //   bus.$off('checkout-step');
  // },

  methods: {

    /**
     * Register with google
     */
    registerWithGoogle() {
       const self = this;
      this.va_spinner(true);
      this.$gAuth
        .signIn()
        .then( async (GoogleUser) => {
          let googleProfile = GoogleUser.getBasicProfile();
          self.form.first_name = googleProfile.getGivenName();
          self.form.last_name = googleProfile.getFamilyName();
          self.form.email = googleProfile.getEmail();
          self.form.social_type = 'google';
          self.form.social_id = GoogleUser.getId();
          this.va_spinner(false);
          
          // saving for autologin
          let googleResponse = GoogleUser.getAuthResponse();
          self.socialAccessToken = googleResponse.access_token 
         
        })
        .catch(error => {
          this.va_spinner(false);
          console.log('error', error)
        })
    },
    /**
     * register with facebook
     */
    registerWithFacebook() {
      const self = this;
      //self.va_spinner(true);
      window.FB.login(async function(response) {
        if (response.authResponse) {
          await window.FB.api('/me', { 
            locale: 'en_US', 
            fields: 'id,first_name,last_name,email,link,gender,locale' 
          }, function(fbData){
            self.va_spinner(false);
            if (fbData.id) {
              self.form.first_name = fbData.first_name;
              self.form.last_name = fbData.last_name;
              self.form.email = fbData.email;
              self.form.social_type = 'facebook';
              self.form.social_id = response.authResponse.userID;

               // saving for autologin
              self.socialAccessToken = response.authResponse.accessToken

            } else {
              self.va_snackbar({
                type: 'warning',
                message: 'Unable to fetch facebook detail.',
              });
            }
          });      
        } else {
          self.va_spinner(false);
          self.va_snackbar({
            type: 'warning',
            message: 'User cancelled login or did not fully authorize.',
          });
        }
      }, { 
        scope: 'email'
      });
      return false;
    },

   /**
     * Login with google
     */
    async loginWithFacebook() {
      const self = this;
      //self.va_spinner(true);
      window.FB.login(async function(response) {
        if (response.authResponse) {

          //let fbUserData = await Helpers.getfacebookUserInfo();
           self.va_spinner(true);
          let res = await self.loginWithSocial({
            social_type: 'facebook',
            access_token: response.authResponse.accessToken
          });
          self.va_spinner(false);

          if(res.status == 200) {
            await self.setLoginSuccessUserData(res);
          } else if (res.response && (res.response.status == 403) ){
            // No registered
            await window.FB.api('/me', { 
              locale: 'en_US', 
              fields: 'id,first_name,last_name,email,link,gender,locale' 
            }, function(fbData){
              if (fbData.id) {
                self.openJoinForm()
                self.form.first_name = fbData.first_name;
                self.form.last_name = fbData.last_name;
                self.form.email = fbData.email;
                self.form.social_type = 'facebook';
                self.form.social_id = response.authResponse.userID;
              } else {
                self.va_snackbar({
                  type: 'warning',
                  message: 'Unable to fetch facebook detail.',
                });
              }
            }); 
            // First remove Fb token that has been set
            //Helpers.removeFbCookeFromLocal();
          } else {
            self.va_spinner(false);
            self.va_snackbar({
              type: res.status == 200 ? 'success' : 'warning',
              message: res.status == 200 ? res.data.msg : res.response.data.msg,
            });
          }
          
        } else {
          self.va_spinner(false);
          self.va_snackbar({
            type: 'warning',
            message: 'User cancelled login or did not fully authorize.',
          });
        }
      }, { 
        scope: 'email'
      });
      return false;
    },


    /**
     * Login with google
     */
    async loginWithGoogle () {
      const self = this;
      this.va_spinner(true);
      this.$gAuth
        .signIn()
        .then( async (GoogleUser) => {
          let googleResponse = GoogleUser.getAuthResponse();

          let res = await self.loginWithSocial({
            social_type: 'google',
            access_token: googleResponse.access_token
          });
     
          if(res.status == 200){
            await this.setLoginSuccessUserData(res);
          }  else if (res.response && (res.response.status == 403) ){
              self.openJoinForm()
              let googleProfile = GoogleUser.getBasicProfile();
              self.form.first_name = googleProfile.getGivenName();
              self.form.last_name = googleProfile.getFamilyName();
              self.form.email = googleProfile.getEmail();
              self.form.social_type = 'google';
              self.form.social_id = GoogleUser.getId();
          }
          // this.va_snackbar({
          //   type: res.status == 200 ? 'success' : 'warning',
          //   message: res.status == 200 ? res.data.msg : res.response.data.msg,
          // });
          this.va_spinner(false);
        })
        .catch(error => {
          this.va_spinner(false);
          console.log('error', error)
        })
    },

    /**
     * Login with social
     */
    async loginWithSocial(data){
      return await LoginApis.loginWithSocial(data);
    },

    /**
     * on success login set datas
     */
    async setLoginSuccessUserData(res) {
      // Push user to vbout
      VboutApis.upsertUser(res.data.payload, this.vg_selectedStore.id);
     
      // If user has email_verification_status = true tag it 
      if(res.data.payload.email_verification_status){
        VboutApis.addUserTag({
          email: res.data.payload.email,
          tagname: 'verified',
        }, this.vg_selectedStore.id);
      }
      // casl_opt_in as marketing notification
      if(res.data.payload.marketing_notification){
        VboutApis.addUserTag({
          email: res.data.payload.email,
          tagname: 'casl_opt_in',
        }, this.vg_selectedStore.id);
      }

      this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
      this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
      this.$store.dispatch("SET_USER_LOGGEDIN_DATE", moment().format('YYYY-MM-DD HH:mm:ss'));

      // fetch order
      let orderHistory = await OrderHistoryApis.fetch(1);
      // fetch user fav location
      UserApis.fetchFavLocations();
      // fetch user fav products
      UserApis.fetchFavProducts();

      // as soon as user logged in remove guest checkout params
      this.va_setGuestLandedQueries({})
      // if we have selected store fetch that store cart items 
      if(!_.isEmpty(this.vg_selectedStore) && this.vg_selectedStore.id != ''){
        
        if(this.vg_cartItems.length == 0){
          // Fetch cart is guest doesnot have any cart
          await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
        } else {
          // Fetch and merge guest and user cart
          // console.log('cart merge alert')
          // parameter i need old cart id , user id , location id
          await CartApis.convertGuestCartToUserCart(Helpers.getLocationCartFullUrl(this));
        }
        // Once we got cart ask for loyalty
        await this.va_setCartLoyalityPointsObj({
          order_receive_method: 'pickup'
        });
      }
    
      if(orderHistory.status == 200) {
        this.va_setAllOrders(orderHistory.data.payload);
      }
   
      this.va_spinner(false);

      // Start loyalty stuffs only if business is active
      if(this.vg_businessLoyality.id && this.vg_businessLoyality.is_active) {

        // Check if user is on loyality or not
        await this.va_setUserLoyalityObj({
          user_id: res.data.payload.id, 
          business_id: this.vg_businessProfile.id
        });

        // If not setup try it, signup hits loyality in it
        let loyaltyJoinRes = await this.va_joinUserOnLoyalityProgram({
          user_id: res.data.payload.id,
          business_id: this.vg_businessProfile.id
        })

        // Signup bonus
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.welcome_bonus > 0) ) {
          // show loyalty bonus point for signup
          bus.$emit('loyality-signup-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.welcome_bonus,
            message: "Sign Up Bonus!",
          })
        }

        // Show loyalty referral point
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.referral_bonus > 0) ) {
          bus.$emit('loyality-referral-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.referral_bonus,
            message: "A little something for being referred!",
          })
        }

        // Store check in bonus
        if( (this.$route.query.in_store == 1) || (this.$route.query.in_store == 'true')){
          let userCheckInres = await UserApis.userLoyalityCheckIn(this.vg_businessProfile.id, this.vg_selectedStore.id, this.vg_selectedStore.name);
          if(userCheckInres.status == 200){
            // alert modal
            bus.$emit('loyality-checkin-congratulations', {
              modal: true,
              point: userCheckInres.data.payload.points_earned,
              message: "You've checked in!",
            })
          }
        }

      }

    },
    
    /**
     * Join loyality programmer
     */
    // async joinLoyalityProgramme() {
    //   let validation = await Helpers.validateRefs(this, ['loyality_terms_conditions']);
    //   if( validation ) {
    //     // Here we need to push user on loyality programme
    //     this.va_spinner(true);
    //     let res = await this.va_joinUserOnLoyalityProgram({
    //       user_id:this.vg_userId, 
    //       business_id: this.vg_businessProfile.id
    //     });
    //     this.va_spinner(false);
    
    //     this.va_snackbar({
    //       type: res.status == 200 ? 'success' : 'warning', 
    //       message: res.status == 200 ? res.data.msg : res.response.data.msg
    //     })
    //   } 
    // },
    
    /**
     * Skip reward 
     */
    async skip() {
      this.join_now = false;
      this.form = Helpers.setObjValueEmpty(this.form);
      this.marketing_notification = false;
      await this.va_setCheckoutReward({
        type: 'skip',
        user: {}
      })
      bus.$emit('checkout-step', {
        step: 'ordertype',
      })
    },

    editStep() {
      bus.$emit('checkout-step', {
        step: 'reward',
      })
    },

    /**
     * On join register
     */
    async join() {
      
      const self = this;
      let validation = await Helpers.validateRefs(this, ['first_name', 'last_name', 'email', 'phone']);
      if( validation ) {

        // let signUpredirectPage = this.$router.resolve({ 
        //   name: 'SignUpAuthenticate',
        //   params: { 
        //      business_slug: this.$route.params.business_slug
        //   },
        // });
        // this.form.redirect_url = window.location.protocol + '//' + window.location.host + signUpredirectPage.href;
        
        let query = Helpers.refineQuery(['token', 'verify_email'], this.$route.query);
        query = new URLSearchParams(query).toString();
        query = query ? '?' + query : '';
        this.form.redirect_url = window.location.protocol + '//' + window.location.host + this.$route.path + query;

        this.va_spinner(true);
        let obj = _.clone(this.form);
        if(!this.signupTypeSocial){
          delete obj['social_type'];
          delete obj['social_id'];
        }

        // Need to Add
        obj.business_id = this.vg_businessProfile.id;
        obj.business_name = this.vg_businessProfile.name;
        obj.business_slug = this.$route.params.business_slug;
        obj.logo_url = (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '';
        obj.location_id = this.vg_selectedStore.id ? this.vg_selectedStore.id : '';
        obj.location_slug = this.vg_selectedStore.slug ? this.vg_selectedStore.slug : '';

        let res = await SignupApis.passwordLessSignup(obj);
        this.va_spinner(false);
        if(res.status == 201){

          // Push user to vbout
          VboutApis.upsertUser(res.data.payload, this.vg_selectedStore.id);
          // If user has marketing_notification pass on vbout
          if(this.form.marketing_notification){
            VboutApis.addUserTag({
              email: this.form.email,
              tagname: 'casl_opt_in',
            }, this.vg_selectedStore.id); 
          }
         
          // Now user dont need to verify age
          this.$store.dispatch('SET_VISITOR_DETAILS', {
            ageVerify: true,
            dob: '',
            province: '',
            remember: false,
          });   


          if(self.signupTypeSocial){
            // now login user if type is social
            let loginRes = await self.loginWithSocial({
              social_type: self.form.social_type,
              access_token: self.socialAccessToken
            });
            if(loginRes.status == 200) {
              await self.setLoginSuccessUserData(res);

            } else {
              await this.va_setCheckoutReward({
                type: 'skip',
                user: {}
              })
            }
          } else {
            await this.va_setCheckoutReward({
              type: 'skip',
              user: {}
            })
          }
          // Reset this form
          this.$refs.registerForm.reset();
          bus.$emit('checkout-step', {
            step: 'ordertype',
          })
        }

        this.va_spinner(false);
        this.va_snackbar({
          type: res.status == 201 ? 'success' : 'warning',
          message: res.status == 201 ? res.data.msg : res.response.data.msg,
        });
        
      } 
    },

    /**
     * Get province age limit
     */
    // getProvinceAge(code) {
    //   if(!code){
    //     return '';
    //   }
    //   let provinceObj = _.find(this.vg_provinces, { value: code });
    //   if(provinceObj){
    //     return provinceObj.age;
    //   }
    //   return '';
    // },

    /**
     * NO account exist on social login so pass it to signup
     */
    openJoinForm() {
      this.join_now = true;
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setCheckoutReward: "checkout/setReward",
      va_setGuestLandedQueries: "location/setGuestLandedQueries",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
      va_setAllOrders: "orderhistory/setAllOrders",
      va_joinUserOnLoyalityProgram: "userloyalitysubscription/joinUserOnLoyalityProgram",
      va_setCartLoyalityPointsObj: "cart/setLoyalityPointsObj",
    })

  },
};
</script>


